__turbopack_context__.v({
  "action": "AIxtnq_action",
  "content": "AIxtnq_content",
  "page": "AIxtnq_page",
  "spin": "AIxtnq_spin",
  "spinner": "AIxtnq_spinner",
});
